import { forwardRef, MouseEventHandler } from 'react'

import { CLICK_CODE_ATTRIBUTE_NAME } from '@place/ui/constants'
import { AnchorProps } from '@place/ui/contexts'

import { useContent } from '@web/libs/contexts/ContentContext'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'

const Anchor = forwardRef<HTMLAnchorElement, AnchorProps>(function Anchor({ children, onClick, ...rest }, ref) {
  const content = useContent()

  const handleClick: MouseEventHandler<HTMLAnchorElement> = event => {
    onClick?.(event)

    // @ts-ignore
    const area = rest[CLICK_CODE_ATTRIBUTE_NAME]
    if (area) {
      sendClickLog({ event, area, contentId: content.id, contentType: content.type })
    }
  }

  return (
    <a role="button" ref={ref} onClick={handleClick} {...rest}>
      {children}
    </a>
  )
})

export default Anchor
